import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"
import { FieldsBehaviour } from "@csrc/assets/data/constants/FieldsBehaviour"

export type SiteDefaultValue = 'title' | 'column'

export interface SiteColumnOptions {
  structure_id?: number
  structure_node_id?: number
  column_id?: number
}

export class SiteOptionsVM extends CommonOptionVM {
  required?: boolean;
  editable?: boolean;
  asset_type_id?: number;
  asset_type_uuid?: string
  field_key?: string;
  field_type?: keyof typeof FieldsBehaviour; // *** Need to check whether it could be undefined or null
  default_value?: SiteDefaultValue
  column_options?: SiteColumnOptions
  [key: string]: any

  constructor(data: Partial<SiteOptionsVM> = {}) {
    super(data)
    this.required = data?.required ?? undefined
    this.editable = data?.editable ?? undefined
    this.asset_type_id = data?.asset_type_id ?? undefined
    this.asset_type_uuid = data?.asset_type_uuid ?? undefined
    this.field_key = data?.field_key ?? undefined
    this.field_type = data?.field_type ?? undefined
    this.default_value = (data?.default_value as SiteDefaultValue) ?? undefined
    this.column_options = this.column_options ? {
      structure_id: data?.column_options?.structure_id ?? undefined,
      structure_node_id: data?.column_options?.structure_node_id ?? undefined,
      column_id: data?.column_options?.column_id ?? undefined
    } : undefined

    // Handle any additional dynamic properties
    for (const key in data) {
      if (!(key in this) && Object.prototype.hasOwnProperty.call(data, key)) {
        (this as any)[key] = data[key]
      }
    }
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default SiteOptionsVM